function encodeArray(arr) {
  const jsonString = JSON.stringify(arr);
  return btoa(jsonString);
}

function decodeArray(encodedStr) {
  const jsonString = atob(encodedStr);
  return JSON.parse(jsonString);
}

function objectToQS(obj) {
  return new URLSearchParams(obj).toString();
}

function objectFromQS(queryString) {
  const params = new URLSearchParams(queryString);
  const queryObj = {};
  for (const [key, value] of params.entries()) {
    queryObj[key] = value;
  }
  return queryObj;
}

if (location.pathname == "/pages/products-compare") {
  const compareList = localStorage.getItem("compareList");
  if (compareList === "" || compareList === null || compareList === undefined) {
    const search = new URL(location.href).search;
    if (search.includes("_ob")) {
      const compareObject = objectFromQS(search);
      const compareRes = compareObject["_ob"];
      const compareResDecoded = decodeArray(compareRes);
      console.log("compareResDecoded", compareResDecoded);
      if (compareResDecoded !== "") {
        localStorage.setItem("compareList", compareResDecoded);
      }
    }
  }
}

var Shopify = Shopify || {};

window.setCookie = function (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");
  for (var i = 0; i < cookieArray.length; i++) {
    var cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === " ") {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return "";
};

document.addEventListener("DOMContentLoaded", function () {
  if (window.Shopify && window.Shopify.collection) {
    var Shopify_collection_handle = "all";
    if (window.Shopify.collection) {
      Shopify_collection_handle = window.Shopify.collection.handle;
    }
    window.Shopify.collection_handle = Shopify_collection_handle;
  }
});
